import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaStar, FaTrophy, FaRedo, FaHome } from 'react-icons/fa';
import './QuizResults.css';

const QuizResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { score, totalQuestions, subject, grade, topic, subtopic, xpEarned } = location.state || {};

    useEffect(() => {
        if (!location.state) {
            navigate('/dashboard');
        }
    }, [location.state, navigate]);

    const handleRetry = () => {
        navigate('/quiz', {
            state: {
                subject,
                grade,
                topic,
                subtopic
            }
        });
    };

    const handleHome = () => {
        navigate('/dashboard');
    };

    if (!location.state) {
        return null;
    }

    return (
        <div className="quiz-results">
            <div className="results-container">
                <div className="score-section">
                    <h1>Quiz Complete!</h1>
                    <div className="score-display">
                        <FaTrophy className="trophy-icon" />
                        <div className="score-text">
                            <h2>Your Score</h2>
                            <p className="score-value">{score}%</p>
                        </div>
                    </div>
                    {xpEarned > 0 && (
                        <div className="xp-earned">
                            <FaStar className="xp-icon" />
                            <div className="xp-text">
                                <h3>XP Earned</h3>
                                <p className="xp-value">+{xpEarned} XP</p>
                            </div>
                        </div>
                    )}
                </div>

                <div className="quiz-info">
                    <h3>Quiz Details</h3>
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="label">Subject:</span>
                            <span className="value">{subject}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Grade:</span>
                            <span className="value">{grade}</span>
                        </div>
                        <div className="info-item">
                            <span className="label">Topic:</span>
                            <span className="value">{topic}</span>
                        </div>
                        {subtopic && (
                            <div className="info-item">
                                <span className="label">Subtopic:</span>
                                <span className="value">{subtopic}</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="action-buttons">
                    <button className="retry-button" onClick={handleRetry}>
                        <FaRedo className="button-icon" />
                        Try Again
                    </button>
                    <button className="home-button" onClick={handleHome}>
                        <FaHome className="button-icon" />
                        Back to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuizResults; 